import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

interface Props extends ChakraV3.LinkProps {
  to: string;
  isExternal?: boolean;
}

export const TextLink = (props: Props) => {
  const { children, to, isExternal, ...rest } = props;

  if (isExternal) {
    return (
      <ChakraV3.Link {...rest} target='_blank' rel='noopener noreferrer' asChild>
        <ReactRouterLink to={to}>{children}</ReactRouterLink>
      </ChakraV3.Link>
    );
  }

  return (
    <ChakraV3.Link {...rest} asChild>
      <ReactRouterLink to={to}>{children}</ReactRouterLink>
    </ChakraV3.Link>
  );
};
